import '../css/Home.css';
import Navbar from '../components/navbar';
import Hero from '../components/hero';
import Services from '../components/services';
import Stack from '../components/stack';
import About from '../components/about';
import Contact from '../components/contact';
import Footer from '../components/footer';

export default function Home() {
  return (
    <div className="site-container">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <div className="wrap" id="details">
          <Stack />
          <About />
          <Contact />
        </div>
      </main>
      <Footer />
    </div>
  );
}
